import React from "react";
import {ChooseApplicationCategoryFeature} from "../../features/chooseApplicationCategory";

const PlatformPage = () => <ChooseApplicationCategoryFeature />
export default PlatformPage;
